import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";

import "../../../packs/translations";
import SpinLoading from "../../shared/spin_loading";

const WeatherGraph = props => {
  const [data, setData] = useState({});
  const [isLoad, setIsLoad] = useState(false);

  const options = {
    title: {
      display: false
    },
    tooltips: {
      mode: "index",
      intersect: false
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          display: true,
          stacked: true
        }
      ],
      yAxes: [
        {
          id: "temperature",
          type: "linear",
          position: "left",
          scalePositionLeft: true,
          display: true,
          scaleLabel: {
            display: true,
            labelString: I18n.t("js.show_tour.y_label")
          },
          ticks: {
            beginAtZero: false,
            stepSize: 10
          },
          gridLines: {
            drawOnChartArea: false
          }
        },
        {
          id: "drop",
          position: "right",
          type: "linear",
          display: true,
          scalePositionLeft: false,
          scaleLabel: {
            display: true,
            labelString: I18n.t("js.show_tour.y_drop_label")
          },
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            drawOnChartArea: false
          }
        }
      ]
    }
  };

  const loadWeather = () => {
    axios
      .get(`/api/hotels/${props.hotel_id}/location_weathers`, {})
      .then(response => {
        const sortedData = response.data.sort((a, b) =>
          a.month > b.month ? 1 : -1
        );
        const temperatureMin = sortedData.map(obj => obj.temperature_min);
        const temperatureMax = sortedData.map(obj => obj.temperature_max);
        const drop = sortedData.map(obj => obj.drop);

        const newData = {
          labels: I18n.t("js.month_names"),
          datasets: [
            {
              yAxisID: "drop",
              label: I18n.t("js.show_tour.drop"),
              type: "line",
              fill: false,
              backgroundColor: "#78a4e5",
              borderColor: "#78a4e5",
              pointBorderColor: "#78a4e5",
              pointBackgroundColor: "#78a4e5",
              pointHoverBackgroundColor: "#78a4e5",
              pointHoverBorderColor: "#78a4e5",
              data: drop
            },
            {
              yAxisID: "temperature",
              label: I18n.t("js.show_tour.minimum"),
              backgroundColor: "white",
              borderWidth: 0,
              hoverBackgroundColor: "white",
              data: temperatureMin,
              fill: false
            },
            {
              yAxisID: "temperature",
              label: I18n.t("js.show_tour.maximum"),
              backgroundColor: "#ffc20e",
              borderWidth: 0,
              data: temperatureMax,
              fill: false
            }
          ]
        };
        setIsLoad(true);
        setData(newData);
      })
      .catch(error => {
        console.log(error.response);
      });
  };

  return (
    <VisibilitySensor
      scrollCheck={true}
      partialVisibility={true}
      onChange={visible => {
        if (visible && !isLoad) {
          loadWeather();
        }
      }}
    >
      <div style={{ width: "100%" }}>
        <SpinLoading show={!isLoad} />
        <Bar data={data} options={options} />
      </div>
    </VisibilitySensor>
  );
};

WeatherGraph.propTypes = {
  hotel_id: PropTypes.number.isRequired
};

export default WeatherGraph;
